<footer>
    <section class="container">
        <nav class="footer-nav-wrapper">
            <div>
                <p class="nav-heading">Quick Links</p>
                <ul role="list" class="links-list">
                    <li class="link-item" *ngFor="let link of quickLinks">
                        <!-- <ng-container *ngIf="userRole === 'ANONYMOUS' && (link.title === 'Zakat Calculator'); else linkTemplate">
                      <button (click)="openAuth()" class=" footer-link d-flex align-items-center">
                         <i class="bi bi-arrow-right"></i>
                         <span>{{ link.title }}</span>
                      </button>
                   </ng-container> -->
                        <!-- <ng-template #linkTemplate> -->
                        <a class="d-flex align-items-center footer-link" *ngIf="link.external; else internalLink"
                            [href]="link.path" [attr.target]="link.target" rel="noopener noreferrer">
                            <!-- <i class="bi bi-arrow-right"></i> -->
                            <span>{{ link.title }}</span>
                        </a>

                        <ng-template #internalLink>
                            <a class="d-flex align-items-center footer-link" [routerLink]="link.path"><span>{{
                                    link.title }}</span></a>
                        </ng-template>
                        <!-- </ng-template> -->
                    </li>
                </ul>
            </div>


            <div>
                <p class="nav-heading">Company</p>
                <ul role="list" class="links-list">
                    <li class="link-item">
                        <a class="d-flex align-items-center footer-link" routerLink="/about-us">
                            <!-- <i class="bi bi-arrow-right"></i> -->
                            <span>About Us</span>
                        </a>
                    </li>
                    <li class="link-item">
                        <a class="d-flex align-items-center footer-link" routerLink="/for-business">
                            <!-- <i class="bi bi-arrow-right"></i> -->
                            <span>For Business</span>
                        </a>
                    </li>
                    <li class="link-item">
                        <a class="d-flex align-items-center footer-link" routerLink="/ambassador-program">
                            <!-- <i class="bi bi-arrow-right"></i> -->
                            <span>Ambassador Program</span>
                        </a>
                    </li>
                    <li class="link-item">
                        <a class="d-flex align-items-center footer-link" routerLink="/screening-methodology">
                            <!-- <i class="bi bi-arrow-right"></i> -->
                            <span>Screening Methodology</span>
                        </a>
                    </li>

                    <li class="link-item">
                        <a class="d-flex align-items-center footer-link" routerLink="/contact-us">
                            <!-- <i class="bi bi-arrow-right"></i> -->
                            <span>Contact Us</span>
                        </a>
                    </li>
                    <!-- <li class="link-item">
                   <a class="d-flex align-items-center footer-link" href="mailto:info@musaffa.com">
                      <i class="bi bi-arrow-right"></i>
                      <span>Contact Us</span>
                   </a>
                </li> -->
                </ul>
            </div>


            <div>
                <p class="nav-heading">Account</p>

                <ul role="list" class="links-list">
                    <li class="link-item" *ngIf="userRole === 'ANONYMOUS'">
                        <a class="d-flex align-items-center footer-link" routerLink="/authentication/login">
                            <!-- <i class="bi bi-arrow-right"></i> -->
                            <span>Login</span>
                        </a>
                    </li>
                    <li class="link-item" *ngFor="let link of premiumLinks">
                        <a class="d-flex align-items-center footer-link" [routerLink]="link.path">
                            <!-- <i class="bi bi-arrow-right"></i> -->
                            <span>{{ link.title }}</span>
                        </a>
                    </li>
                </ul>
            </div>


            <div>
                <p class="nav-heading">Legal</p>
                <ul role="list" class="links-list">
                    <li class="link-item">
                        <a class="d-flex align-items-center footer-link" routerLink="/terms-of-use">
                            <!-- <i class="bi bi-arrow-right"></i> -->
                            <span>Terms of Use</span>
                        </a>
                    </li>
                    <li class="link-item">
                        <a class="d-flex align-items-center footer-link" routerLink="/privacy-policy">
                            <!-- <i class="bi bi-arrow-right"></i> -->
                            <span>Privacy Policy</span>
                        </a>
                    </li>
                    <li class="link-item">
                        <a class="d-flex align-items-center footer-link" routerLink="/disclosure-library">
                            <!-- <i class="bi bi-arrow-right"></i> -->
                            <span>Disclosure Library</span>
                        </a>
                    </li>
                    <li class="link-item">
                        <a class="d-flex align-items-center footer-link" routerLink="/disclaimer">
                            <!-- <i class="bi bi-arrow-right"></i> -->
                            <span>General Disclaimer</span>
                        </a>
                    </li>
                    <li class="link-item">
                        <a class="d-flex align-items-center footer-link" routerLink="/brand-guidelines">
                            <!-- <i class="bi bi-arrow-right"></i> -->
                            <span>Brand Guidelines</span>
                        </a>
                    </li>

                    <!-- <li class="link-item">
                  <a class="d-flex align-items-center footer-link" href="mailto:info@musaffa.com">
                     <i class="bi bi-arrow-right"></i>
                     <span>Contact Us</span>
                  </a>
               </li> -->
                </ul>
            </div>


            <div>
                <p class="nav-heading">Install Our App</p>
                <p *ngIf="!isMobile" class="mb-3 d-none d-lg-block scan-text">Scan QR code to install app</p>
                <div class="store_badges">
                    <div class="qr_code" *ngIf="!isMobile">
                        <img src="/assets/images/footer/qr-code.png" alt="qr-code" class="img-fluid d-none d-lg-block">
                    </div>
                    <div class="app_store_row">
                        <a href="https://app.musaffa.com/wKcRlYiPpKb" target="_blank">
                            <img src="/assets/images/home/footer-ios-app.svg" alt="app-store-badge" class="img-fluid">
                        </a>
                        <a href="https://app.musaffa.com/mcJZc85OpKb" target="_blank">
                            <img src="/assets/images/home/footer-gplay.svg" alt="play-store-badge" class="img-fluid">
                        </a>
                        <a *ngIf="!isMobile"
                            href="https://chromewebstore.google.com/detail/musaffa-halal-stock-scann/khhlfpiekiijfkpcobnfcagchfepnfla"
                            target="_blank" class="d-inline-flex text-decoration-none align-items-center">
                            <img src="/assets/images/home/footer-chrome-ext.svg" alt="Google Chrome Extension"
                                class="img-fluid">
                        </a>
                    </div>
                </div>
            </div>

        </nav>
        <nav>
            <div class="collapse-div py-0 text-white">
                <button type="button" class="d-flex gap-3 border-0 text-white bg-transparent w-100 align-items-center justify-content-between" (click)="stockCollapse.toggle()" [attr.aria-expanded]="!isMostSearchStocksCollapsed">
                    Most Searched Stocks
                    <svg [class.rotate-icon]="!isMostSearchStocksCollapsed" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 9-7 6-7-6"/>
                    </svg>
                </button>
                <div #stockCollapse="ngbCollapse" [(ngbCollapse)]="isMostSearchStocksCollapsed">
                    <div class="list-grid pt-0 pb-3 pb-lg-4">
                        <div *ngFor="let group of mostSearchedStocks">
                            <p class="country-heading fw-500 mb-3">{{group.heading}}</p>
                            <ul role="list" class="m-0 d-grid">
                                <li *ngFor="let item of group.data" class="">
                                    <a [routerLink]="item.url" class="fw-300 d-block asset-link">{{item.title}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="collapse-div py-0 text-white">
                <button type="button" class="d-flex gap-3 border-0 text-white bg-transparent w-100 align-items-center justify-content-between" (click)="etfCollapse.toggle()" [attr.aria-expanded]="!isMostSearchETFsCollapsed">
                    Most Searched ETFs
                    <svg [class.rotate-icon]="!isMostSearchETFsCollapsed" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 9-7 6-7-6"/>
                    </svg>
                </button>
                <div #etfCollapse="ngbCollapse" [(ngbCollapse)]="isMostSearchETFsCollapsed">
                    <div class="list-grid pt-0 pb-3 pb-lg-4">
                        <div *ngFor="let group of mostSearchETFs">
                            <p class="country-heading fw-500 mb-3">{{group.heading}}</p>
                            <ul role="list" class="m-0 d-grid">
                                <li *ngFor="let item of group.data" class="">
                                    <a [routerLink]="item.url" class="fw-300 d-block asset-link">{{item.title}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
        <div class="mb-0 footer-para d-flex flex-wrap flex-column flex-lg-row align-items-lg-center gap-2 gap-lg-3">
            <a class="text-white" href="https://reports.adviserinfo.sec.gov/crs/crs_338525.pdf" target="_blank" rel="noopener noreferrer">Form CRS</a>
            <div class="d-none d-lg-block">|</div>
            <a class="text-white" href="https://adviserinfo.sec.gov/firm/summary/338525" target="_blank" rel="noopener noreferrer">SEC Registered Investment Advisor (IAPD)</a>
            <div class="d-none d-lg-block">|</div>
            <a class="text-white" href="https://brokercheck.finra.org/search/genericsearch/firmgrid" target="_blank" rel="noopener noreferrer">FINRA Broker Check</a>
        </div>
        <div class="mb-0 footer-para">
            <div class="py-1">
                The Musaffa Global Halal Investing Platform (“<strong>Platform</strong>”) is a Shariah-compliant investment digital platform offered by Musaffa LLC (“ <strong>Musaffa</strong>”), a U.S. SEC-registered investment adviser (RIA) <span class="text-nowrap">( <a class="text-white text-nowrap" href="https://brokercheck.finra.org/search/genericsearch/firmgrid" target="_blank" rel="noopener noreferrer">CRD #338525</a> / <a class="text-white text-nowrap" href="https://adviserinfo.sec.gov/firm/summary/338525" target="_blank" rel="noopener noreferrer">SEC #801-134527</a> )</span>. SEC registration does not imply a certain level of skill, expertise, or endorsement of any entity, product, or service discussed herein. Under the Platform, Musaffa provides educational, research, and screening platform services (non-advisory), self-directed recommendations advisory services with trading functionality, and discretionary portfolio management advisory services. Users should review Musaffa’s brochure and Form ADV Part 2A for details regarding services, fees, risks, and conflicts of interest. 
            </div>

            <div class="py-1">
                Musaffa LLC is not a broker-dealer, and has entered into a clearing agreement with Alpaca Securities LLC, a member of FINRA and SIPC
                <button type="button" [ngbTooltip]="sipcContent" triggers="click:blur" class="border-0 text-white bg-transparent">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                    </svg>
                </button>
                , for execution and clearing of trades. All trades are conducted through third-party broker-dealers. 
            </div>

            <div class="py-1">
                All investments involve risk, including the potential loss of principal. The value of securities and other investments may fluctuate due to market conditions, economic factors, or other external influences, and past performance is not indicative of future results. The materials, data, and information on the Platform are provided solely for general informational and educational purposes and are not investment advice, a recommendation to buy or sell any security, or a solicitation to transact. Users are responsible for their own investment decisions and should consult independent legal, financial, and tax advisors. References to Shariah compliance are based on Musaffa’s proprietary methodology and AAOIFI standards, and do not guarantee compliance or outcomes under all circumstances.
            </div>

            <div class="py-1">
                Certain services are only available in jurisdictions where legally permitted. Accessing the Platform from other locations is at the user’s own risk and subject to local laws. Musaffa does not guarantee the accuracy, timeliness, or completeness of any information on the Platform, which is subject to change without notice. The Platform may include third-party content, which is provided “as is” without warranty of any kind.
            </div>

            <div class="py-1">
                PLEASE READ THIS FULL DISCLOSURE CAREFULLY. BY USING THE PLATFORM OR CLICKING AGREE, YOU ACCEPT TO BE BOUND BY THESE DISCLOSURES AND ALL TERMS AND CONDITIONS.
            </div>

            <div class="py-1">
                All trademarks, service marks, trade names, and logos displayed on the Platform are the property of their respective owners. References to third-party products, services, or providers do not constitute endorsement or recommendation by Musaffa.
            </div>

            <div class="py-1">
                Please visit our <a routerLink="/disclosure-library" class="text-white">Disclosures Library</a> for further information. 
            </div>
            <!-- <div class="py-1">
                <strong>Halal trading platform</strong> offered by Musaffa LLC, which operates the Musaffa halal investment digital platform (“<strong>Platform</strong>”), is not a broker-dealer and has entered into a clearing agreement with ALPACA SECURITIES LLC (“<strong>Alpaca Securities</strong>”), a member of FINRA and Securities Investor Protection Corporation (SIPC)
                <button type="button" [ngbTooltip]="sipcContent" triggers="click:blur" class="border-0 text-white bg-transparent">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                    </svg>
                </button>
                . Review our <a routerLink="/trading-service-fee-schedule" class="text-white">fee schedule</a> for more information. 
            </div> -->
            <!-- <div class="py-1">
                <strong>Investment management and advisory services</strong> offered by Musaffa LLC, a U.S. SEC Registered Investment Advisor (RIA) - (<a href="https://brokercheck.finra.org/search/genericsearch/firmgrid" target="_blank" rel="noopener noreferrer" class="text-white">CRD # 338525</a> / <a href="https://adviserinfo.sec.gov/firm/summary/338525" target="_blank" rel="noopener noreferrer" class="text-white">SEC#:801-134527</a> ). Such registration should in no way imply that the SEC has endorsed entities, products, or services discussed herein. Musaffa does not provide, solicit, or execute any securities transactions. Registration as an RIA does not imply a certain level of skill or training. Review the <a href="https://files.adviserinfo.sec.gov/IAPD/Content/Common/crd_iapd_Brochure.aspx?BRCHR_VRSN_ID=990068" target="_blank" rel="noopener noreferrer" class="text-white">company’s brochure</a> for more information regarding the services, fees, risks, and conflicts of interest. 
            </div> -->
            <!-- <div class="py-1">
                All investments involve risk, including the potential loss of principal. The value of securities and other investments may fluctuate due to market conditions, economic factors, or other external influences, and past performance is not indicative of future results. The materials, data, and information made available on the Platform are provided solely for general informational and educational purposes and shall not be construed as investment advice, a recommendation to buy or sell any security, or a solicitation to engage in any transaction. Users are solely responsible for their investment decisions and are strongly encouraged to seek independent legal, financial, and tax advice before making any investment.
            </div> -->
            <!-- <div class="py-1">
                Musaffa does not guarantee the accuracy, timeliness, or completeness of any information made available on the Platform. Information is subject to change without notice.  Reasonable efforts are made to maintain the integrity of the content; however, Musaffa assumes no responsibility for errors, misprints, or out-of-date information provided on the Platform. The Platform may include data, products, services, or other content provided by third-party sources. Musaffa does not control or assume responsibility for any third-party content. All products, services, and content obtained from third-party content are provided “as is” without warranty of any kind, express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, title, non-infringement, security, or accuracy.
            </div> -->
            <!-- <div class="py-1">
                PLEASE READ THIS FULL DISCLOSURE CAREFULLY BEFORE USING THIS SERVICE. BY USING THE SERVICE OR CLICKING AGREE, YOU ARE AGREEING TO BE BOUND BY THESE DISCLOSURES AND ALL TERMS AND CONDITIONS ON THIS WEBSITE/PLATFORM.
            </div> -->
            <!-- <div class="py-1">
                All trademarks, service marks, trade names, and logos displayed on the Platform are the property of their respective owners. References to third-party products, services, or providers do not constitute endorsement or recommendation by Musaffa.
            </div> -->
            <!-- <div class="py-1">
                Please visit our <a routerLink="/disclosure-library" class="text-white">Disclosures Library</a> for further information.
            </div> -->
        </div>
        <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 border-0 copyright-wrapper">
            <div class="d-flex align-items-center flex-wrap gap-2 gap-md-3">
                <!-- <a 
                    href="//www.dmca.com/Protection/Status.aspx?ID=2fca99bb-f4cc-4280-801a-7312692a8641" 
                    title="DMCA.com Protection Status" 
                    class="dmca-badge"
                > 
                    <img src ="https://images.dmca.com/Badges/dmca_protected_sml_120m.png?ID=2fca99bb-f4cc-4280-801a-7312692a8641"  alt="DMCA.com Protection Status" />
                </a>
                <script src="https://images.dmca.com/Badges/DMCABadgeHelper.min.js"> </script> -->

                <a 
                    href="//www.dmca.com/Protection/Status.aspx?ID=79d2fbda-fa14-4e0b-b7a3-015a110e3e9a" 
                    title="DMCA.com Protection Status" 
                    class="dmca-badge"
                > 
                    <img src ="https://images.dmca.com/Badges/dmca_protected_sml_120m.png?ID=79d2fbda-fa14-4e0b-b7a3-015a110e3e9a"  alt="DMCA.com Protection Status" />
                </a>  
                
                <script src="https://images.dmca.com/Badges/DMCABadgeHelper.min.js"> </script>
                
                <!-- <a href="//www.dmca.com/Protection/Status.aspx?ID=79d2fbda-fa14-4e0b-b7a3-015a110e3e9a"
                    title="DMCA.com Protection Status" class="dmca-badge">
                    <img src="https://images.dmca.com/Badges/dmca-badge-w100-5x1-01.png?ID=79d2fbda-fa14-4e0b-b7a3-015a110e3e9a"
                        alt="DMCA.com Protection Status" />
                </a>
                <script src="https://images.dmca.com/Badges/DMCABadgeHelper.min.js"> </script> -->
                
                <p class="mb-0">Musaffa® is a registered trademark of Musaffa, Inc. All rights reserved.</p>
            </div>
            <ul role="list" class="d-flex align-items-center gap-3 gap-lg-4">
                <li class="social-link-item">
                    <a class="d-flex align-items-center" href="https://www.linkedin.com/company/musaffa"
                        target="_blank">
                        <i class="bi bi-linkedin"></i>
                    </a>
                </li>
                <li class="social-link-item">
                    <a class="d-flex align-items-center" href="https://www.facebook.com/musaffa.fintech"
                        target="_blank">
                        <i class="bi bi-facebook"></i>
                    </a>
                </li>
                <li class="social-link-item">
                    <a class="d-flex align-items-center" href="https://x.com/Musaffa_Fintech" target="_blank">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white"
                            class="bi bi-twitter-x" viewBox="0 0 16 16">
                            <path
                                d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
                        </svg>
                    </a>
                </li>
                <li class="social-link-item">
                    <a class="d-flex align-items-center" href="https://www.instagram.com/musaffa.fintech/"
                        target="_blank">
                        <i class="bi bi-instagram"></i>
                    </a>
                </li>
                <li class="social-link-item">
                    <a class="d-flex align-items-center" href="https://www.youtube.com/@musaffafintech" target="_blank">
                        <i class="bi bi-youtube"></i>
                    </a>
                </li>
            </ul>
        </div>
        <div class="mb-0 footer-para">
            <div class="py-1">
                The term halal, when applied to investments, is subject to multiple interpretations. We define halal investments as investments permitted by Shariah law. Shariah-compliant investments are investment products governed by the requirements of Shariah law and the principles of the Islamic religion.
            </div>
            <div class="py-1">
                *#1 Website in the Halal Investment Research: Per web analytics of Similarweb, Semrush, and Similar Sites in comparison to competitors for the year of 2024.
            </div>
        </div>
    </section>
</footer>

<ng-template #sipcContent>
    ALPACA SECURITIES LLC (“Alpaca”), a member of FINRA and Securities Investor Protection Corporation (SIPC), will serve as the custodian for your securities account. In the event that Alpaca fails and is placed in liquidation under the Securities Investor Protection Act, securities in your brokerage account may be protected up to $500,000. For details, please see <a href="http://www.sipc.org" target="_blank" rel="noopener noreferrer">www.sipc.org</a>.
</ng-template>